export type BonificoTransferReasonCustomer = {
  firstName: string;
  lastName: string;
  taxCode: string;
  email: string;
};

const TRANSFER_REASON_SEPARATOR = " - ";

export const GENERIC_TRANSFER_REASON_PREFIX = `Nome Cognome Codice fiscale${TRANSFER_REASON_SEPARATOR}Email${TRANSFER_REASON_SEPARATOR}`;

export function bonificoTransferReasonPrefix(
  customer: BonificoTransferReasonCustomer,
): string {
  const identity = [
    customer.firstName.trim(),
    customer.lastName.trim(),
    customer.taxCode.trim().toUpperCase(),
  ]
    .filter(Boolean)
    .join(" ");
  return `${identity}${TRANSFER_REASON_SEPARATOR}${customer.email.trim()}${TRANSFER_REASON_SEPARATOR}`;
}
